import React from 'react';
import { Table } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
export default function ProjectNestedData(_ref) {
  let {
    project,
    projectClaimGroups
  } = _ref;
  const {
    t
  } = useTranslation();
  const headers = [{
    text: t('bsfz')
  }, {
    text: t('project')
  }];
  const rows = projectClaimGroups.map(claimGroup => ({
    key: claimGroup.id,
    columns: [claimGroup.name, project.project_name]
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "ProjectsTabNestedProjectsTable"
  }, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows
  }));
}